import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { catchError, finalize, of } from "rxjs";
import { LoaderService } from "src/app/shared/components/loader/loader.service";
import { BillingResolverData } from "./billing.model";
import { BillingService } from "./billing.service";

export const billingResolver: ResolveFn<BillingResolverData> = () => {
  const billingService = inject(BillingService);
  const loaderSvc = inject(LoaderService);

  const emptyResult: BillingResolverData = { billing: null, plans: [] };

  loaderSvc.show();

  return billingService.loadBillingPageData().pipe(
    catchError((error) => {
      console.error("Error fetching billing resolver data:", error);
      billingService.setBillingResolverData(emptyResult);
      return of(emptyResult);
    }),
    finalize(() => {
      loaderSvc.hide();
    }),
  );
};
